import React from 'react';
import { Box, Item, Span, Image } from '../../library/react-html-email';

/**
 * EmailVehicleSpec - Email-safe vehicle specification component
 * Displays vehicle details matching the mobile app design with car icon
 */
const EmailVehicleSpec = ({ equipment, registration, t, assetPath, selectedFamily }) => {
  const model = equipment?.model || {};

  // Map vehicle families to their corresponding icons
  const iconMap = {
    'cars': 'car.png',
    'vans': 'van.png',
    'commercial': 'commercial.png',
    'agricultural': 'agricultural.png',
    'off-highway': 'off-highway.png'
  };

  const currentIcon = iconMap[selectedFamily] || 'car.png';



  return (
    <Box
      width="100%"
      align="left"
      style={{ backgroundColor: '#ffffff' }}
    >
      {/* Vehicle Badge with Car Icon */}
      <Item style={{ padding: '24px 24px 16px 24px' }}>
        <table cellPadding="0" cellSpacing="0" border="0" style={{ display: 'inline-block' }}>
          <tr>
            <td
              style={{
                verticalAlign: 'middle',
                padding: '8px 12px',
                background: 'rgba(0, 0, 0, 0.05)',
                borderRadius: '2px'
              }}
            >
              <table cellPadding="0" cellSpacing="0" border="0">
                <tr>
                  <td style={{ verticalAlign: 'middle', paddingRight: '8px' }}>
                    <Image
                      src={assetPath + 'images/email/' + currentIcon}
                      alt={selectedFamily || 'Car'}
                      width={24}
                      height={24}
                      style={{
                        display: 'block',
                        opacity: '0.75'
                      }}
                    />
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <Span
                      fontSize={16}
                      color="#202020"
                      style={{
                        fontWeight: '600',
                        fontFamily: 'Arial, sans-serif',
                        lineHeight: '24px'
                      }}
                    >
                      {t('vehicle_spec.car_details')}
                    </Span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </Item>

      {/* Vehicle Make and Model */}
      <Item style={{ padding: '0 24px 4px 24px' }}>
        {model.manufacturer && (
          <Span
            fontSize={24}
            color="#202020"
            style={{
              fontWeight: '600',
              fontFamily: 'Arial, sans-serif',
              lineHeight: '32px',
              display: 'inline-block',
              paddingRight: '8px'
            }}
          >
            {model.manufacturer}
          </Span>
        )}
        {(model.series || model.model) && (model.series || model.model) !== model.display_name_short && (
          <Span
            fontSize={24}
            color="#202020"
            style={{
              fontWeight: '600',
              fontFamily: 'Arial, sans-serif',
              lineHeight: '32px',
              display: 'inline-block'
            }}
          >
            {model.series || model.model}
          </Span>
        )}
      </Item>

      {/* Full Model Name */}
      {model.display_name_short && (
        <Item style={{ padding: '0 24px 16px 24px' }}>
          <Span
            fontSize={24}
            color="#202020"
            style={{
              fontWeight: '600',
              fontFamily: 'Arial, sans-serif',
              lineHeight: '32px',
              display: 'block'
            }}
          >
            {model.display_name_short}
          </Span>
        </Item>
      )}

      {/* Vehicle Details - Inline with Separators */}
      <Item style={{ padding: '0 24px 24px 24px' }}>
        <Span
          fontSize={16}
          color="#202020"
          style={{
            fontFamily: 'Arial, sans-serif',
            lineHeight: '24px',
            opacity: '0.75'
          }}
        >
          {[
            registration && { label: t('vehicle_spec.reg'), value: registration },
            model.manufacturer && { label: t('vehicle_spec.manufacturer'), value: model.manufacturer },
            (model.series || model.model) && { label: t('vehicle_spec.model'), value: model.series || model.model },
            model.year_from && { label: t('vehicle_spec.year'), value: model.year_from },
            !!model.displacement && { label: t('vehicle_spec.engine_size'), value: model.displacement },
            model.fuel && { label: t('vehicle_spec.fuel_type'), value: model.fuel },
          ].filter(Boolean).map((item, index, arr) => (
            <React.Fragment key={index}>
              {item.label} <Span style={{ fontWeight: '600' }}>{item.value}</Span>
              {index < arr.length - 1 && <Span style={{ padding: '0 8px', opacity: '0.75' }}>|</Span>}
            </React.Fragment>
          ))}
        </Span>
      </Item>
    </Box>
  );
};

export default EmailVehicleSpec;
